// Model.js
// -----------------------
// @module Case
// eslint-disable-next-line no-undef
define('Tavano.TTUserActivityTracking.Model', ['Backbone', 'Utils'], function (Backbone, Utils) {
  'use strict';

  // @class Case.Fields.Model @extends Backbone.Model
  return Backbone.Model.extend({
    //@property {String} urlRoot
    urlRoot: Utils.getAbsoluteUrl(
      // eslint-disable-next-line no-undef
      getExtensionAssetsPath('Modules/TTUserActivityTracking/SuiteScript2/TTUserActivityTracking.Service.ss'),
      true
    )
  });
});
